import apiClient from "../../api/api";

/**
 * @description Fetches application settings filtered by setting name.
 * Currently, it retrieves settings related to Single Sign-On (SSO).
 *
 * @async
 * @function requestGetSettings
 * @returns {Promise<any>} A promise that resolves with the settings data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestGetSettings = async() => {
    const params = {
        settingName: "SSO"
    }
    const getSettingsResponse = await apiClient.get(import.meta.env.VITE_SETTINGS_BASE_URL, { params })
    return getSettingsResponse.data
}

/**
 * @description Updates application settings.
 *
 * @async
 * @function requestUpdateSettings
 * @param {Object} settings - The settings payload to be updated.
 *
 * @returns {Promise<any>} A promise that resolves with the updated settings data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestUpdateSettings = async(settings) => {
    const updateSettingsResponse = await apiClient.put(import.meta.env.VITE_SETTINGS_BASE_URL, settings, {successToast:"Settings updated"})

    return updateSettingsResponse.data

}